import React from 'react';
import {message} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import createHistory from 'history/createHashHistory';
import {getLoginUser} from "@utils/NHCore";
import './index.css';
import NHFetch from "../../../../utils/NHFetch";
import {mkbz} from './menuObj';
import NHCascader from "@components/common/NHCascader";
const history = createHistory();


const menu = {
    tzgg:[],//通知通告
    zzbd:[],//自助报到
    dhlj:[],//导航链接
};



export default class _siderMenu extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        menuType: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.state={
            menuList:[],//菜单列表
            unShowBlzt:['GD009'],
            BlztMc:{
                GD002:['已购买','未购买'],
                GD005:['已审核','已申请','未申请']
            },
            // shzt:false
        }
    }

    componentDidMount(){
        const {menuType,flmid} = this.props;
        const tzgg = menu.tzgg;
        const zzbd = menu.zzbd;
        const dhlj = menu.dhlj;
        if(menuType === '通知公告'){
            if(tzgg && tzgg.length==0){
                this.loadXxbfMenuList(tzgg);
            }else{
                this.setState({menuList:tzgg},()=>{
                    if(this.props.setMenuList){
                        this.props.setMenuList(tzgg);
                    }
                });
            }
        }

        if(menuType === '自助报到'){
            if(zzbd && zzbd.length==0){
                this.loadMenuList(zzbd);
            }else{
                this.setState({menuList:zzbd},()=>{
                    if(this.props.setMenuList){
                        this.props.setMenuList(zzbd);
                    }
                });
            }
        }

        if(menuType ==='导航链接'){
            if(dhlj && dhlj.length==0 && flmid){
                this.loadDhljList(dhlj,flmid);
            }else{
                this.setState({menuList:dhlj});
            }
        }
    }

    componentWillReceiveProps(nextProps){
        const {menuType,mkbz} = this.props;
        if(menuType ==='导航链接' && !this.state.flmid&& nextProps.flmid!=''){
            const dhlj = menu.dhlj;
            this.loadDhljList(dhlj,nextProps.flmid);
        }
    }

    getLstdXcShzt = () => {
        NHFetch('/openapi/yxwz/getLstdXcShzt', 'GET')
            .then(res => {
                if (res) {
                    if(res.data !== '0' && res.data !== null){
                        this.setState({ shzt: true })
                    }
                }
            })
    }

    loadDhljList=(menuList,flmid)=>{
        let userId = getLoginUser() ? getLoginUser().userId : '';
        let xsfs = '';
        if(userId){
            xsfs = 1;
        }
        let params = {
            flmid:flmid,
            xsfs:xsfs,
        }

        NHFetch('/dhlm/getDhljList','GET',params).then(resData => {
            if (resData && resData.data) {
                if(menuList.length>0){
                    menuList = [];
                }
                menuList.push(...resData.data);
                this.setState({menuList:resData.data});
            }
        });
    }

    reloadMenuList=()=>{
        const zzbd = menu.zzbd;
        this.loadMenuList(zzbd);
    }

    loadMenuList=(menuList)=>{
        NHFetch('/zzbd/getZzbdInfoList','GET').then(resData => {
            if (resData && resData.data) {
                if(menuList.length>0){
                     menuList.splice(0,menuList.length);
                }
                menuList.push(...resData.data);
                this.setState({menuList:resData.data},()=>{
                    if(this.props.setMenuList){
                     this.props.setMenuList(resData.data);
                    }
                    //this.getLstdXcShzt();
                });
            }
        });
    }

    loadXxbfMenuList=(menuList)=>{
        NHFetch('front/zhxg-unauth/yxwz/loadXxbfMenuList','GET').then(resData => {
            if (resData && resData.data) {
                if(menuList.length>0){
                    menuList = [];
                }
                menuList.push(...resData.data);
                this.setState({menuList:resData.data},()=>{
                    if(this.props.setMenuList){
                        this.props.setMenuList(resData.data);
                    }
                });
            }
        });
    }

    toLink_GD=(hjdm,pkid)=>{
        if(pkid && this.isLogin()){
            history.push({
                    pathname:mkbz[hjdm],
                    search:'pkid='+pkid,
                }
            );
        }
    }

    toLink_ZDY=(hjdm,pkid,lx)=>{
        if(pkid && this.isLogin()){
            history.push({
                    pathname:'/customLink',
                    search:'pkid='+pkid+'&mkbz='+hjdm+"&lx="+lx,
                }
            );
        }
    }

    isLogin=()=>{
        let userId = getLoginUser() ? getLoginUser().userId : '';
        if(!userId){
            message.warning("未获取登录信息。");
            history.push({
                pathname:'/index',
                });
            return false;
        }
        return true;
    }


    render() {
        const { className, title, menuType, active,url} = this.props;
        let menuList = this.state.menuList;
        let unShowBlzt = this.state.unShowBlzt;
        let blztMc = this.state.BlztMc;
        if (menuType === '通知公告') {
           /* menuList = [
                { title: '入学须知' },
                { title: '交通路线' },
                { title: '校园风景' },
                { title: '视频简介' },
                { title: '军训服装' }
            ];*/
        }

        if (menuType === '自助报到') {
         /*   menuList = [
                { title: '个人信息填写', url: '/update_info' },
                { title: '物品购买', url: '/buy' },
                { title: '军训服装尺码', url: '/size' },
                { title: '报到情况填写', url: '/report' },
                { title: '绿色通道申请', url: '/channel' },
                { title: '自选宿舍', url: '/dorm' },
                { title: '专业调整', url: '/major' },
                { title: '网上缴费', url: '/pay' },
                { title: '入学报到单打印', url: '/print' }
            ];*/
        }



        return (
            <div className={className} styleName="sider_menu">
                <div styleName="sider_menu_title">{title}</div>
                {menuList && title==='自助报到'&&
                menuList.length>0 &&
                menuList.map((elem, index) => {
                    let hjlx = elem.HJLX;
                    let showBlzt = true;
                    let i = unShowBlzt.indexOf(elem.HJDM);
                    if(i>0 || i==0){
                            showBlzt = false;
                    }

                    let mcList = blztMc[elem.HJDM];
                    let ztmc = '';
                    if(mcList){
                        if(elem.HJDM === 'GD005'){
                            ztmc=elem.shzt&&elem.shzt!=='0'?mcList[0]:(elem.BLZT&&elem.BLZT==1?mcList[1]:mcList[2]);
                        }else{
                            ztmc = elem.BLZT&&elem.BLZT==1?mcList[0]:mcList[1];
                        }
                    }else{
                        ztmc = elem.BLZT&&elem.BLZT==1?'已办理':'未办理';
                    }

                    return (
                        hjlx==1?
                        <div
                            key={index}
                            styleName={classNames('sider_menu_item', {
                                active: elem.HJDM === this.props.mkbz
                            })}
                            onClick={() => {
                                this.toLink_GD(elem.HJDM,elem.PKID);
                            }}
                        >
                            {elem.HJMC}{showBlzt&&<span className={elem.BLZT&&elem.BLZT==1?"":"text-info-red"}>({ztmc})</span>}
                        </div>:<div
                                key={index}
                                styleName={classNames('sider_menu_item', {
                                    active: elem.HJDM === this.props.mkbz
                                })}
                                onClick={() => {
                                    this.toLink_ZDY(elem.HJDM,elem.PKID,elem.LX)
                                }}
                            >
                                {elem.HJMC}{showBlzt&&<span className={elem.BLZT&&elem.BLZT==1?"":"text-info-red"}>({ztmc})</span>}
                            </div>
                    );
                })}

                {menuList && title==='通知公告'&&
                menuList.length>0 &&
                menuList.map((elem, index) => {
                    return (
                        <div
                            key={index}
                            styleName={classNames('sider_menu_item', {
                                active: elem.FLBZ === this.props.flbz
                            })}
                            onClick={() => {
                                if(elem.FLBZ){
                                    if(elem.SFNRWY==1){
                                        history.push({
                                                pathname:'/notice/detail',
                                                search:'pkid='+elem.PKID,
                                            }
                                        );
                                    }else{
                                        history.push({
                                                pathname:'/notice',
                                                search:'flbz='+elem.FLBZ,
                                            }
                                        );
                                    }
                                }
                            }}
                        >
                            {elem.FLBT}
                        </div>
                    )
                })}

                {menuList && title==='导航链接'&&
                menuList.length>0 &&
                menuList.map((elem, index) => {
                    return (
                        <div
                            key={index}
                            styleName={classNames('sider_menu_item', {
                                active: elem.pkid === this.props.pkid
                            })}
                            onClick={() => {
                                if(elem.lmlj){
                                    history.push({
                                            pathname:'/link',
                                            search:'pkid='+elem.pkid,
                                        }
                                    );
                                    window.open(elem.lmlj);
                                }
                            }}
                        >
                            {elem.lmmc}
                        </div>
                    )
                })}
            </div>
        );
    }
}
//属性检查
_siderMenu.propTypes = {
    setMenuList: PropTypes.func, //选择完成后的回调
}


// WEBPACK FOOTER //
// ./app/pages/Assembly/siderMenu/index.js